import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import AppShell from './components/AppShell/AppShell';
import RequireAuth from './components/RequireAuth';
import LoginPage from './pages/login/LoginPage';
import WelcomePage from './pages/welcome/WelcomePage';
import RulesPage from './pages/rules/RulesPage';
import SuspectsPage from './pages/suspects/SuspectsPage';
import ThankYouPage from './pages/thankYou/ThankYouPage';
import Round1Page from './pages/games/round1/Round1Page';
import Round2Page from './pages/games/round2/Round2Page';
import Round3Page from './pages/games/round3/Round3Page';
import Round4Page from './pages/games/round4/Round4Page';

function App() {
  return (
    <Provider store={store}>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />

        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/rules" element={<RulesPage />} />
          <Route path="/suspects" element={<SuspectsPage />} />
          <Route path="/rounds/1" element={<Round1Page />} />
          <Route path="/rounds/2" element={<Round2Page />} />
          <Route path="/rounds/3" element={<Round3Page />} />
          <Route path="/rounds/4" element={<Round4Page />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/hub" element={<Navigate to="/welcome" replace />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
